import type { FlexProps} from '@chakra-ui/react'
import { Flex, forwardRef } from '@chakra-ui/react'

interface StepProps extends FlexProps {
  isPassed?: boolean
  passedColor?: string
}

const Step = forwardRef(
  ({ children, sx, isPassed, passedColor, ...rest }: StepProps, ref) => {
    return (
      <Flex
        ref={ref}
        sx={{
          w: '10px',
          h: '10px',
          bg: isPassed
            ? (passedColor ?? 'step-progress-passed-bg')
            : 'trasparent',
          borderRadius: 'full',
          ...sx,
        }}
        {...rest}
      >
        {children}
      </Flex>
    )
  },
)

export interface StepsProgressProps extends FlexProps {
  progress: number
  passedColor?: string
}

export const StepsProgress = forwardRef(
  (
    { children, progress, passedColor, sx, ...rest }: StepsProgressProps,
    ref,
  ) => {
    return (
      <Flex
        ref={ref}
        sx={{ h: 5, gap: 'px', alignItems: 'center', ...sx }}
        {...rest}
      >
        {Array.from({ length: 4 }).map((_, index) => (
          <Step
            key={index}
            isPassed={index < progress}
            passedColor={passedColor}
          />
        ))}
      </Flex>
    )
  },
)
